import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { api, inr } from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const [booking, setBooking] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      if (attempts >= 8) {
        setStatus("timeout");
        return;
      }
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (data.status === "expired" || data.payment_status === "failed") {
          setStatus("error");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setTimeout(poll, 2000);
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div className="px-4 py-24 text-center max-w-md mx-auto" data-testid="payment-success-page">
      {status === "checking" && (
        <>
          <Loader2 className="h-12 w-12 mx-auto text-primary animate-spin" />
          <h1 className="font-display font-bold text-2xl mt-4">Confirming your payment...</h1>
          <p className="text-muted-foreground mt-1">Please wait a moment.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="h-16 w-16 mx-auto text-emerald-500" />
          <h1 className="font-display font-extrabold text-3xl mt-4" data-testid="payment-paid">
            Booking confirmed!
          </h1>
          <p className="text-muted-foreground mt-2">
            Thank you for booking with Book My Event. Our team will reach out shortly to finalise your celebration.
          </p>
          <button
            onClick={() => navigate("/")}
            className="mt-6 px-6 h-11 bg-primary text-white rounded-full font-semibold"
          >
            Back to home
          </button>
        </>
      )}
      {(status === "error" || status === "timeout") && (
        <>
          <XCircle className="h-16 w-16 mx-auto text-destructive" />
          <h1 className="font-display font-bold text-2xl mt-4">Payment not confirmed</h1>
          <p className="text-muted-foreground mt-2">
            {status === "timeout"
              ? "This is taking longer than expected. If money was debited, it will reflect soon."
              : "We couldn't confirm your payment."}
          </p>
          <button
            onClick={() => navigate("/cart")}
            className="mt-6 px-6 h-11 border border-primary text-primary rounded-full font-semibold"
          >
            Back to cart
          </button>
        </>
      )}
    </div>
  );
}
